import { Fragment, ReactElement, useMemo } from 'react';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import {
  AuthenticAuthorizations,
  CashCheckAuthorization,
  CertificationAuthorizations,
  ClaimsAuthorizations,
  RegisterCertificationAuthorizations,
  TypeDocAuthorizations,
  StatementsAuthorizations,
  HistoricalAuthorizations,
  ResidencyPermitAuthorizations,
  ReleaseModeAuthorizations,
  PrintReceiptPosAuthorizations,
  RegistrationIDCardAuthorizations,
  ReleaseIdCardAuthorizations,
  CashManagementAuthorizations,
  LotsManagementAuthorizations,
  ReprintCidAuthorizations,
  RetrieveIdCardAuthorizations,
  AmountAuthorizations,
  AnnullamentIDCardAuthorizations,
} from 'shell/authorizations/front-office';
import CardCollapse from './card-collapse';
import { DisabledCardMenu } from 'shell/view-models/disabled-menu';

interface NestedItemsFrontOfficeIdentityCardProps {
  link: string;
  onSubItemClick?: () => void;
}

const NestedItemsFrontOfficeIdentityCard = ({
  link,
  onSubItemClick,
}: NestedItemsFrontOfficeIdentityCardProps): ReactElement => {
  const actions = useActionAuthorization({
    certificazione: CertificationAuthorizations,
    attestazione: ClaimsAuthorizations,
    autentiche: AuthenticAuthorizations,
    dichiarazioni: StatementsAuthorizations,
    storiche: HistoricalAuthorizations,
    controlloDiCassa: CashCheckAuthorization,
    ricercaRegistro: RegisterCertificationAuthorizations,
    tipoDoc: TypeDocAuthorizations,
    permessoDiSoggiorno: ResidencyPermitAuthorizations,
    modalitaRilascio: ReleaseModeAuthorizations,
    stampaRicevutPos: PrintReceiptPosAuthorizations,
    registrazioneCarta: RegistrationIDCardAuthorizations,
    annullamentoCarta: AnnullamentIDCardAuthorizations,
    rilascioCarta: ReleaseIdCardAuthorizations,
    leva: HistoricalAuthorizations,
    elettorale: HistoricalAuthorizations,
    ufficioCassa: CashManagementAuthorizations,
    gestioneLotti: LotsManagementAuthorizations,
    ristampaCid: ReprintCidAuthorizations,
    recuperoCartelliniCie: RetrieveIdCardAuthorizations,
    ricercaImporto: AmountAuthorizations,
  });

  const visibilityCard = useMemo(() => {
    return (
      !actions.rilascioCarta &&
      !actions.ristampaCid &&
      !actions.registrazioneCarta &&
      !actions.gestioneLotti &&
      !actions.recuperoCartelliniCie
    );
  }, [actions]);

  return (
    <Fragment>
      {visibilityCard ? undefined : (
        <CardCollapse
          link={link}
          onSubItemClick={onSubItemClick}
          active={
            {
              ...(actions || {}),
            } as DisabledCardMenu
          }
        />
      )}
    </Fragment>
  );
};

NestedItemsFrontOfficeIdentityCard.displayName =
  'nested Items front office identity card component';

export default NestedItemsFrontOfficeIdentityCard;
